import { render, staticRenderFns } from "./DocutaxClientDetail.vue?vue&type=template&id=1f298835&scoped=true&"
import script from "./DocutaxClientDetail.vue?vue&type=script&lang=js&"
export * from "./DocutaxClientDetail.vue?vue&type=script&lang=js&"
import style0 from "./DocutaxClientDetail.vue?vue&type=style&index=0&id=1f298835&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f298835",
  null
  
)

export default component.exports